/** Textes des pages de paiement, traduits. */
export const PAY = {
  fr: {
    checking: "Vérification du paiement…",
    authorizedTitle: "Demande de réservation enregistrée !",
    depositTitle: "Caution enregistrée avec succès !",
    depositNote: "Votre empreinte bancaire a bien été enregistrée : aucun montant n'a été débité. La somme reste simplement bloquée sur votre compte pendant le séjour, puis est libérée automatiquement dans les 48 h suivant votre départ, sauf dégradation constatée et justifiée.",
    depositHeld: "Caution bloquée (aucun débit)",
    authorizedNote: "Votre empreinte bancaire a bien été prise : aucun montant n'a été débité. Le propriétaire valide votre séjour sous 48 h et vous recevrez un email dès sa réponse. Le débit n'aura lieu qu'après sa validation.",
    held: "Montant pré-autorisé",
    checkingNote: "Merci de ne pas fermer cette page.",
    confirmed: "Réservation confirmée !",
    confirmedNote: "Un email de confirmation vous attend. Nous vous enverrons les informations d'arrivée quelques jours avant votre séjour.",
    thanks: "Merci",
    arrival: "Arrivée",
    departure: "Départ",
    nights: "Nuits",
    guests: "Voyageurs",
    paid: "Montant payé",
    home: "Retour à l'accueil",
    pendingTitle: "Paiement en cours de traitement",
    failedTitle: "Le paiement n'a pas abouti",
    pendingNote: "Votre banque finalise l'autorisation. Aucun montant n'est débité à ce stade : nous vous écrirons par email dès que la demande sera enregistrée, puis dès la validation du propriétaire.",
    failedNote: "Aucun montant n'a été débité. Vous pouvez réessayer ou nous contacter.",
    retry: "Réessayer",
    contact: "Nous contacter",
    cancelTitle: "Paiement annulé",
    cancelNote: "Votre réservation n'a pas été validée et aucun montant n'a été débité. Les dates restent disponibles pour le moment.",
    backCal: "Revenir au calendrier",
    homeShort: "Accueil",
  },
  en: {
    checking: "Checking your payment…",
    authorizedTitle: "Booking request received!",
    depositTitle: "Deposit successfully registered!",
    depositNote: "Your card imprint has been registered: no amount has been charged. The sum is simply held on your account during the stay, then released automatically within 48 hours after your departure, unless damage is found and documented.",
    depositHeld: "Deposit held (no charge)",
    authorizedNote: "Your card has been pre-authorised: no amount has been charged. The owner will confirm your stay within 48 hours and you will receive an email with their answer. You will only be charged once they approve.",
    held: "Pre-authorised amount",
    checkingNote: "Please do not close this page.",
    confirmed: "Booking confirmed!",
    confirmedNote: "A confirmation email is waiting for you. We will send the arrival details a few days before your stay.",
    thanks: "Thank you",
    arrival: "Check-in",
    departure: "Check-out",
    nights: "Nights",
    guests: "Guests",
    paid: "Amount paid",
    home: "Back to home",
    pendingTitle: "Payment being processed",
    failedTitle: "The payment did not go through",
    pendingNote: "Your bank is still finalising the authorisation. No amount is charged at this stage: we will email you as soon as the request is recorded, then again once the owner confirms.",
    failedNote: "No amount has been charged. You can try again or contact us.",
    retry: "Try again",
    contact: "Contact us",
    cancelTitle: "Payment cancelled",
    cancelNote: "Your booking has not been confirmed and no amount has been charged. The dates remain available for now.",
    backCal: "Back to the calendar",
    homeShort: "Home",
  },
  de: {
    checking: "Zahlung wird geprüft…",
    authorizedTitle: "Buchungsanfrage eingegangen!",
    depositTitle: "Kaution erfolgreich erfasst!",
    depositNote: "Ihre Kartenreservierung wurde erfasst: es wurde kein Betrag abgebucht. Der Betrag wird lediglich während des Aufenthalts auf Ihrem Konto blockiert und innerhalb von 48 Stunden nach der Abreise automatisch freigegeben, sofern keine Schäden festgestellt und belegt werden.",
    depositHeld: "Kaution blockiert (keine Abbuchung)",
    authorizedNote: "Ihre Karte wurde vorautorisiert: es wurde kein Betrag abgebucht. Der Gastgeber bestätigt Ihren Aufenthalt innerhalb von 48 Stunden und Sie erhalten eine E-Mail mit der Antwort. Die Abbuchung erfolgt erst nach der Bestätigung.",
    held: "Vorautorisierter Betrag",
    checkingNote: "Bitte schließen Sie diese Seite nicht.",
    confirmed: "Buchung bestätigt!",
    confirmedNote: "Eine Bestätigungs-E-Mail wartet auf Sie. Die Anreiseinformationen senden wir einige Tage vor Ihrem Aufenthalt.",
    thanks: "Vielen Dank",
    arrival: "Anreise",
    departure: "Abreise",
    nights: "Nächte",
    guests: "Gäste",
    paid: "Bezahlter Betrag",
    home: "Zurück zur Startseite",
    pendingTitle: "Zahlung wird verarbeitet",
    failedTitle: "Die Zahlung war nicht erfolgreich",
    pendingNote: "Ihre Bank schließt die Autorisierung noch ab. Es wird derzeit kein Betrag abgebucht: wir schreiben Ihnen, sobald die Anfrage erfasst ist und erneut nach der Bestätigung des Gastgebers.",
    failedNote: "Es wurde kein Betrag abgebucht. Sie können es erneut versuchen oder uns kontaktieren.",
    retry: "Erneut versuchen",
    contact: "Kontakt aufnehmen",
    cancelTitle: "Zahlung abgebrochen",
    cancelNote: "Ihre Buchung wurde nicht bestätigt und es wurde kein Betrag abgebucht. Die Daten bleiben vorerst verfügbar.",
    backCal: "Zurück zum Kalender",
    homeShort: "Startseite",
  },
  es: {
    checking: "Verificando el pago…",
    authorizedTitle: "¡Solicitud de reserva registrada!",
    depositTitle: "¡Fianza registrada correctamente!",
    depositNote: "Su preautorización ha quedado registrada: no se ha cobrado ningún importe. La cantidad solo queda bloqueada en su cuenta durante la estancia y se libera automáticamente en las 48 h posteriores a su salida, salvo daños constatados y justificados.",
    depositHeld: "Fianza bloqueada (sin cobro)",
    authorizedNote: "Su tarjeta ha sido preautorizada: no se ha cobrado ningún importe. El propietario validará su estancia en un plazo de 48 h y recibirá un correo con su respuesta. El cobro solo se realizará tras su validación.",
    held: "Importe preautorizado",
    checkingNote: "No cierre esta página, por favor.",
    confirmed: "¡Reserva confirmada!",
    confirmedNote: "Le espera un correo de confirmación. Le enviaremos la información de llegada unos días antes de su estancia.",
    thanks: "Gracias",
    arrival: "Llegada",
    departure: "Salida",
    nights: "Noches",
    guests: "Viajeros",
    paid: "Importe pagado",
    home: "Volver al inicio",
    pendingTitle: "Pago en proceso",
    failedTitle: "El pago no se ha completado",
    pendingNote: "Su banco está finalizando la autorización. No se cobra ningún importe en esta fase: le escribiremos en cuanto se registre la solicitud y de nuevo tras la validación del propietario.",
    failedNote: "No se ha cobrado ningún importe. Puede volver a intentarlo o contactarnos.",
    retry: "Intentar de nuevo",
    contact: "Contáctenos",
    cancelTitle: "Pago cancelado",
    cancelNote: "Su reserva no ha sido validada y no se ha cobrado ningún importe. Las fechas siguen disponibles por ahora.",
    backCal: "Volver al calendario",
    homeShort: "Inicio",
  },
  it: {
    checking: "Verifica del pagamento…",
    authorizedTitle: "Richiesta di prenotazione registrata!",
    depositTitle: "Cauzione registrata con successo!",
    depositNote: "La vostra preautorizzazione è stata registrata: nessun importo è stato addebitato. La somma resta solo bloccata sul vostro conto durante il soggiorno e viene liberata automaticamente entro 48 ore dalla partenza, salvo danni constatati e documentati.",
    depositHeld: "Cauzione bloccata (nessun addebito)",
    authorizedNote: "La vostra carta è stata preautorizzata: nessun importo è stato addebitato. Il proprietario convaliderà il soggiorno entro 48 ore e riceverete un'email con la risposta. L'addebito avverrà solo dopo la convalida.",
    held: "Importo preautorizzato",
    checkingNote: "Non chiudete questa pagina.",
    confirmed: "Prenotazione confermata!",
    confirmedNote: "Vi attende un'email di conferma. Invieremo le informazioni per l'arrivo alcuni giorni prima del soggiorno.",
    thanks: "Grazie",
    arrival: "Arrivo",
    departure: "Partenza",
    nights: "Notti",
    guests: "Ospiti",
    paid: "Importo pagato",
    home: "Torna alla home",
    pendingTitle: "Pagamento in elaborazione",
    failedTitle: "Il pagamento non è andato a buon fine",
    pendingNote: "La vostra banca sta completando l'autorizzazione. Nessun importo viene addebitato in questa fase: vi scriveremo appena la richiesta sarà registrata e di nuovo dopo la convalida del proprietario.",
    failedNote: "Nessun importo è stato addebitato. Potete riprovare o contattarci.",
    retry: "Riprova",
    contact: "Contattaci",
    cancelTitle: "Pagamento annullato",
    cancelNote: "La vostra prenotazione non è stata convalidata e nessun importo è stato addebitato. Le date restano disponibili per ora.",
    backCal: "Torna al calendario",
    homeShort: "Home",
  },
};
